/* ============================================================
   KOAKI™ Prelander — Shopify asset
   Loaded once (guarded). No-JS safe: reveals default visible in CSS;
   JS "arms" them (hides) then reveals on scroll. Re-inits on
   Shopify theme-editor section events so content shows while editing.
   ============================================================ */
(function () {
  'use strict';
  if (window.__koakiPrelander) return;
  window.__koakiPrelander = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }) : null;

  var countObs = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { animateCount(e.target); countObs.unobserve(e.target); } });
  }, { threshold: 0.6 }) : null;

  function armReveals(root, forceShow) {
    root.querySelectorAll('.reveal').forEach(function (el) {
      if (el.__armed) return; el.__armed = true;
      if (forceShow || reduce || !io) { el.classList.add('is-in'); return; }
      el.classList.add('is-armed');
      io.observe(el);
    });
  }

  function initCounters(root, forceShow) {
    root.querySelectorAll('[data-count]').forEach(function (el) {
      if (el.__counted) return; el.__counted = true;
      if (forceShow || reduce || !countObs) { el.textContent = el.getAttribute('data-count'); return; }
      countObs.observe(el);
    });
  }

  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    var dur = 1400, start = null;
    function tick(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased);
      if (p < 1) requestAnimationFrame(tick); else el.textContent = target;
    }
    requestAnimationFrame(tick);
  }

  function initFaq(root) {
    root.querySelectorAll('.faq__list').forEach(function (list) {
      if (list.__faq) return; list.__faq = true;
      var items = list.querySelectorAll('.qa');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (o) { if (o !== item) o.open = false; });
        });
      });
    });
  }

  function initAll(root, forceShow) {
    armReveals(root, forceShow);
    initCounters(root, forceShow);
    initFaq(root);
  }

  /* Sticky CTA visibility */
  function onScroll() {
    var sticky = document.querySelector('.koaki-sticky-cta');
    if (sticky) sticky.classList.toggle('is-visible', window.scrollY > 700);
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* Smooth in-page anchors */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href');
    if (!id || id.length < 2) return;
    var t = document.querySelector(id);
    if (t) { e.preventDefault(); t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
  });

  /* Boot */
  function boot() { initAll(document, false); onScroll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Shopify theme editor: init newly loaded/edited sections and force-show */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target, true); });
  document.addEventListener('shopify:section:select', function (e) { initAll(e.target, true); });
})();
